import React from 'react';
import { Paper, Typography } from '@mui/material';
import { CheckCircle, Cancel } from '@mui/icons-material';

import { analyticsTile } from "../../types/types";
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';




export function AnalyticsTile(props: analyticsTile) {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT = "Analytics Dashboard"

  return (

      <Paper elevation={3} sx={{width:"10rem",height:"6rem", p:1, display: 'flex', flexDirection: 'row', alignItems: 'center',justifyContent:"space-around"}}>
        <div style={{display:"flex", flexDirection:"column"}}>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
        {translate(TranslationEnum.analytics_dashboard,props.heading)}
        </Typography>
        <Typography variant="body1" color={props.status === 'Healthy' ? 'primary' : 'error'} sx={{ mb: 1 }}>
        {translate(TranslationEnum.analytics_dashboard,props.status)}
        </Typography>
        </div>
      
        {props.status === 'Healthy'? <CheckCircle sx={{color:"#24c6b1"}} fontSize="large" /> : <Cancel color="error" fontSize="large" />}
      </Paper>
  
  );
};

export default AnalyticsTile;
